
// Country services rest api calling

import { routes } from '../config/api_routes'

export const invoiceService = {

    // get country 
    // info: sortDesc : Boolean
    
    getInvoices: (formData) => window.axios.post(routes.InvoiceListApi,formData),
    downloadInvoice:(formData) => window.axios.post(routes.InvoiceDownloadApi,formData,{ responseType:'blob'}),
    invoicePay:(formData) => window.axios.post(routes.orderItemPayApi,formData)

}